export default __webpack_public_path__ + "static/nodle-efd338110001c6e2a7818c0923614d67.svg";